import React, { useEffect, useState } from "react";

import Navbar from "components/Navbar";
import VillaDorada from "../../common/assets/images/villa-dorada.jpg";

import { AssetTypes } from "common/utils/types";
import { ContentWrapper } from "components/ContentWrapper";
import { GetOfferings } from "common/graphql/queryDescriptors";
import { Property } from "../../common/store/property/types";
import { PropertyInfo } from "./components/PropertyInfo";
import { ScreenWidth } from "common/utils/width";
import { StoreState } from "common/store/types";
import { useCustomQuery } from "common/store/hooks/useCustomQuery";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import {
  Box,
  Grid,
  Typography,
  makeStyles,
  CircularProgress,
  AppBar,
  Tabs,
  Tab,
  isWidthUp,
  withWidth,
} from "@material-ui/core";

import "./BrowseProperties.scss";

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

const indicatorStyle = makeStyles({
  root: {
    borderTopRightRadius: 25,
    borderTopLeftRadius: 25,
    height: "90px",
  },
  indicator: {
    backgroundColor: "#0059E2",
    height: 4,
  },
});

const tabStyle = makeStyles({
  root: {
    height: "90px",
  },
  wrapper: {
    fontSize: "24px",
    fontWeight: 500,
  },
});

const appBarStyle = makeStyles({
  root: {
    marginBottom: "100px",
  },
  colorPrimary: {
    backgroundColor: "transparent",
    borderTopRightRadius: 25,
    borderTopLeftRadius: 25,
  },
});

interface Props {
  property: Property;
  screenWidth: ScreenWidth;
  selected: boolean;
}

const PropertyCard = ({ property, screenWidth, selected }: Props) => {
  return (
    <>
      {(!selected || isWidthUp("md", screenWidth)) && (
        <Grid
          item
          container
          justify="center"
          className={"property" + (selected ? "--selected" : "")}
        >
          <Grid
            item
            className={"image-container" + (selected ? "--selected" : "")}
          >
            <img
              className={selected ? "selected" : ""}
              src={VillaDorada}
              alt=""
            />
          </Grid>

          <Grid
            item
            className={"info-container" + (selected ? "--selected" : "")}
          >
            <PropertyInfo property={property} selected={selected} />
          </Grid>
        </Grid>
      )}
    </>
  );
};

function BrowseProperties({ width }: any) {
  const appBar = appBarStyle();
  const indicator = indicatorStyle();
  const tab = tabStyle();

  const [value, setValue] = React.useState(0);

  const handleChange = (_: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  const { t } = useTranslation();

  useCustomQuery(GetOfferings);

  const storageProperties = useSelector<StoreState, Property[]>(
    (state) => state.properties
  );

  const [selectedProperty, setSelectedProperty] = useState<Property>();
  const [selectedLoan, setSelectedLoan] = useState<Property>();

  useEffect(() => {
    if (
      !selectedProperty &&
      storageProperties &&
      storageProperties.length > 0
    ) {
      const firstRealState = storageProperties.find(
        (element: any) => element.token.asset_type === AssetTypes.REAL_ESTATE
      );
      const firstLoan = storageProperties.find(
        (element: any) =>
          element.token.asset_type === AssetTypes.LOAN &&
          element.token.id === "5"
      );

      setSelectedProperty(firstRealState);
      setSelectedLoan(firstLoan);
    }
  }, [storageProperties, selectedProperty]);

  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <div>{children}</div>}
      </div>
    );
  }

  function a11yProps(index: any) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    <Box>
      <Navbar />

      <ContentWrapper paddingTop="0px">
        <Box className="browse-properties">
          <Box
            bgcolor="transparent"
            marginX="26px"
            marginY="100px"
            display="flex"
            height="85px"
            justifyContent="center"
            alignItems="center"
          >
            <Typography color="textSecondary" variant="h1" className="title">
              {t("Browse Offerings")}
            </Typography>
          </Box>

          <Grid
            item
            container
            direction="row"
            justify="center"
            alignItems="center"
            className={"content"}
          >
            <AppBar position="static" classes={appBar}>
              <Tabs
                centered
                variant="fullWidth"
                classes={indicator}
                value={value}
                onChange={handleChange}
                aria-label="simple tabs example"
              >
                <Tab
                  label={t("Loans")}
                  classes={tab}
                  {...a11yProps(0)}
                  style={
                    value === 0 ? { color: "#0059E2" } : { color: "#696F74" }
                  }
                />
              </Tabs>
            </AppBar>

            {storageProperties ? (
              <TabPanel value={value} index={0}>
                {selectedLoan && (
                  <PropertyCard
                    selected={true}
                    property={selectedLoan}
                    screenWidth={width}
                  />
                )}

                <Grid container spacing={6}>
                  {storageProperties.map((property: Property) =>
                    property.token.asset_type === AssetTypes.LOAN ? (
                      <Grid
                        item
                        key={`property-${property.id}`}
                        lg={4}
                        md={6}
                        sm={12}
                        xs={12}
                      >
                        <Box
                          width="auto"
                          onClick={() => setSelectedProperty(property)}
                        >
                          <PropertyCard
                            screenWidth={width}
                            selected={false}
                            property={property}
                          />
                        </Box>
                      </Grid>
                    ) : null
                  )}
                </Grid>
              </TabPanel>
            ) : (
              <CircularProgress color="secondary" />
            )}
          </Grid>
        </Box>
      </ContentWrapper>
    </Box>
  );
}

export default withWidth()(BrowseProperties);
